import React from 'react'
import { Column, Row } from '@/components/layout/layout'

import './stock-update-detail.scss'
import { getBEMCls } from '@/utils/classname'
import { IUser } from '@/model/types/user'

interface StockUpdateDetailProps {
    update_time?: string
    creator?: {
        id: number
        user: IUser
    }
    status?: number
}

const StockReduceDetail: React.FC<StockUpdateDetailProps> = props => {
    const cls = (...arg: string[]) => getBEMCls('stock-update-detail', ...arg)

    return (
        <div className={cls('container')}>
            <Column data-justify-content-center data-expaned>
                <div className={cls('list-item')}>
                    <div className="title coll">盘点时间：</div>
                    <div className="txt">{props.update_time}</div>
                </div>

                <div data-margin-top-12 className={cls('list-item')}>
                    <div className="title coll">操作人：</div>
                    <Row className="txt" data-align-items-center>
                        <img data-margin-right-6 src={props.creator?.user.avatar} alt="" className="avatar" />
                        <div data-width-126 className="text-popper">
                            {props.creator?.user.realname || props.creator?.user.nickname}
                        </div>
                    </Row>
                </div>
            </Column>
            <Column data-justify-content-center data-expaned>
                <div className={cls('list-item')}>
                    <div className="title coll">状态：</div>
                    <div className={`txt ${props.status ? 'them-color' : 'danger-color'}`}>
                        {props.status ? '已盘点' : '草稿'}
                    </div>
                </div>
            </Column>
        </div>
    )
}

export default StockReduceDetail
